import { isEmpty } from 'lodash'

/**
 * Checks if the array contains any of the provided values.
 * @param {Array} values - The array of values to check within.
 * @param {Array|string} checkValues - The value(s) to check for in the array.
 * @returns {boolean} - Returns true if any of the checkValues are found in the values array, otherwise false.
 */
export const hasAny = (values, checkValues) => {
  if (isEmpty(values) || isEmpty(checkValues)) return false
  if (checkValues.length === 0) return false

  if (Array.isArray(checkValues)) {
    return values.some((value) => checkValues.includes(value))
  } else {
    return values.includes(checkValues)
  }
}
